<div class="locataires-form-fields" [formGroup]="form">
  <label>
    {{ 'locataires.ajout.civilite' | translate }}
    <span class="locataires-optional">{{ 'common.optional' | translate }}</span>
    <select formControlName="civilite" autocomplete="honorific-prefix">
      <option value="">{{ 'common.dash' | translate }}</option>
      @for (civilite of civilites; track civilite) {
        <option [value]="civilite">
          {{ civilite | i18nValue: 'ref.civilite' }}
        </option>
      }
    </select>
  </label>

  <div class="locataires-form-row">
    <label>
      {{ 'locataires.ajout.nom' | translate }}
      <input type="text" formControlName="nom" autocomplete="family-name" />
    </label>
    <label>
      {{ 'locataires.ajout.prenom' | translate }}
      <input type="text" formControlName="prenom" autocomplete="given-name" />
    </label>
  </div>

  <div class="locataires-form-row">
    <label>
      {{ 'locataires.ajout.telephone' | translate }}
      <input type="tel" formControlName="telephone" autocomplete="tel" />
    </label>
    <label>
      {{ 'locataires.ajout.email' | translate }}
      <span class="locataires-optional">{{ 'common.optional' | translate }}</span>
      <input type="email" formControlName="mail" autocomplete="email" />
    </label>
  </div>

  <div class="locataires-form-row">
    <label>
      {{ 'locataires.ajout.dateNaissance' | translate }}
      <span class="locataires-optional">{{ 'common.optional' | translate }}</span>
      <input type="date" formControlName="dateNaissance" autocomplete="bday" />
    </label>
    <label>
      {{ 'locataires.ajout.villeNaissance' | translate }}
      <span class="locataires-optional">{{ 'common.optional' | translate }}</span>
      <input type="text" formControlName="villeNaissance" />
    </label>
  </div>

  <label>
    {{ 'locataires.ajout.logement' | translate }}
    <select formControlName="logementId">
      <option value="">{{ 'common.chooseEllipsis' | translate }}</option>
      @for (logement of logements; track logement.idLogementDto) {
        <option [value]="logement.idLogementDto">
          {{ optionLabel(logement) }}
        </option>
      }
    </select>
  </label>
  @if (logementId) {
    <p class="locataires-meuble-hint">
      {{
        selectedMeuble
          ? ('locataires.ajout.logementMeuble' | translate)
          : ('locataires.ajout.logementNonMeuble' | translate)
      }}
    </p>
  }

  <div class="locataires-form-row">
    <label>
      {{ 'locataires.ajout.dateEntree' | translate }}
      <span class="locataires-optional">{{ 'common.optional' | translate }}</span>
      <input type="date" formControlName="dateEntree" />
    </label>
    <label>
      {{ 'locataires.ajout.dateBail' | translate }}
      <span class="locataires-optional">{{ 'common.optional' | translate }}</span>
      <input type="date" formControlName="dateBail" />
    </label>
  </div>

  <label>
    {{ 'locataires.ajout.dateCles' | translate }}
    <span class="locataires-optional">{{ 'common.optional' | translate }}</span>
    <input type="date" formControlName="dateCles" />
  </label>

  <label>
    {{ 'locataires.ajout.etudiant' | translate }}
    <select formControlName="etudiant">
      <option [ngValue]="false">{{ 'common.no' | translate }}</option>
      <option [ngValue]="true">{{ 'common.yes' | translate }}</option>
    </select>
  </label>

  <div class="locataires-duree">
    <span class="locataires-duree-label">
      <span class="locataires-label-line">
        {{ 'locataires.ajout.dureeBail' | translate }}
        <app-help-tip [textKey]="dureeBailHintKey" />
      </span>
    </span>
    <div class="locataires-duree-inputs">
      <input
        type="number"
        formControlName="dureeValeur"
        min="1"
        step="1"
        [attr.aria-label]="'locataires.ajout.dureeBailValeur' | translate"
        />
      <select
        formControlName="dureeUnite"
        [attr.aria-label]="'locataires.ajout.dureeBailUnite' | translate"
        >
        @for (unite of dureeUnites; track unite) {
          <option [value]="unite">
            {{ ('locataires.ajout.unite.' + unite) | translate }}
          </option>
        }
      </select>
    </div>
    @if (dureeBailInvalid) {
      <p class="locataires-field-error">{{ dureeBailErrorKey | translate }}</p>
    }
  </div>
</div>
